import React from "react";

const InternetArticle = ({ content }) => {
  return (
    <section className="my-10">
      <div className="container not-italic font-normal">
        <p className="text-5xl text-center uppercase text-black mb-10">
          Recent internet <strong>article</strong>
        </p>
        <div className="shadow-medium rounded-t-[20px] lg:rounded-t-none px-6 py-10">
          {content}
        </div>
      </div>
    </section>
  );
};

export default InternetArticle;
